// extracted by mini-css-extract-plugin
module.exports = {"error":"styles_error__1-p-c","root":"styles_root__3utM6"};